import { PropertyData } from '@aloft/toolkit-shared';
import { createAction } from '@reduxjs/toolkit';

type LoadCompPayload = {
  id: string;
} & PropertyData;

export const loadNewComps = createAction<{ comps: LoadCompPayload[]; compSequence: string[] }>(
  'loadNewComps',
);
